<button type="button" #button class="academic-panel-btn" [class.active]="active" (click)="selectButton.next(null)" (mouseenter)="enterAndShowTooltip(1000)">
  <yat-tooltip-info-icon
    iconClass="btn-ico-tooltip"
    [tooltipContent]="tooltipContent"
    [tooltipClass]="tooltipClass + ' tooltip-inside-btn'"
    [appendToBody]="true"
    [tooltipPlacement]="tooltipPlacement"
    [manualTooltip]="true"
    [applyHoverState]="tooltipIsShown"
    (mouseEnter)="enterAndShowTooltip(0)">
  </yat-tooltip-info-icon>
  <ng-content></ng-content>
</button>
